'use strict';

(function () {
    angular
        .module('tracking')
        .component('crewListComponent', {
            templateUrl: 'tracking/components/crew-list-component.tpl.html',
            controller: function ($timeout, $scope, applicationConstants, TrackingHelper, trackingConstants, MessageService, EventManagerService) {
                var vm = this;
                vm.selectedPairing = null;
                vm.selectedCrew = null;
                vm.isAddCrewVisible = false;

                vm.$onChanges = function (changeObj) {
                    if (changeObj.selectedDiscrepancy &&
                        changeObj.selectedDiscrepancy.currentValue &&
                        (changeObj.selectedDiscrepancy.currentValue != changeObj.selectedDiscrepancy.previousValue)) {
                        if (vm.crewList) {
                            highlightCrew();
                        }
                    }

                    if (changeObj.crewList &&
                        changeObj.crewList.currentValue &&
                        (changeObj.crewList.currentValue != changeObj.crewList.previousValue)) {
                        highlightCrew();
                    }
                };

                vm.onAssignedCrewClick = function (crew) {
                    setSelectedCrew(crew);
                };

                vm.onViewSchedule = function (crew) {
                    vm.onViewProfile({crew: crew});
                };

                vm.onRemoveCrewClick = function (crew) {
                    var param = {
                        crewProfileId: crew.crewProfileId,
                        crewScheduleBlockId: crew.crewScheduleBlockId
                    };
                    TrackingHelper.unAssignCrew(param,
                        function (result) {
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRACKING.GET_PAIRING_FOR_SELECTED_FLIGHT);
                        },
                        function (error) {
                            MessageService.error(error);
                        }
                    );
                };
                
                vm.onAddMoreCrewClick = function () {
                    setSelectedCrew(null);
                };

                function scrollToTop() {
                    angular.element('.crew-list-container').animate({scrollTop: 0}, "fast");
                };

                function scrollToBottom() {
                    var ele = angular.element('.crew-list-container');
                    ele.animate({scrollTop: ele[0].scrollHeight}, "fast");
                };

                function setSelectedCrew(crew) {
                    vm.selectedCrew = crew;
                    vm.onCrewSelected({crew: crew});
                };

                function highlightCrew() {
                    vm.selectedPairing = TrackingHelper.getSelectedPairing();

                    var markedElementIndex = [];

                    var moveToTop = function (elementIndexCol) {
                        if (elementIndexCol) {
                            $timeout(function () {
                                angular.forEach(elementIndexCol, function (markedObjIndex, key) {
                                    //Perform Shifting only if they are in random positions
                                    if (markedObjIndex != key) {
                                        var ObjectToBeChange = vm.crewList[markedObjIndex];
                                        vm.crewList.splice(markedObjIndex, 1);
                                        vm.crewList.unshift(ObjectToBeChange);
                                    }
                                });
                                setSelectedCrew(vm.crewList[0]);
                            },1);
                        }
                    };

                    var actions = {};

                    actions[trackingConstants.DESCRIPANCY_TYPES.EXP_WARNING] = function () {
                        var expCrewList = TrackingHelper.getValidationExpiredCrews(vm.selectedPairing.patternId);
                        var expCrewProfileIdList = _.pluck(expCrewList, 'crewProfileId') || [];
                        markedElementIndex.length = 0;
                        angular.forEach(vm.crewList, function (crew, index) {
                            crew.isExpired = (expCrewProfileIdList.indexOf(crew.crewProfileId) >= 0);
                            if (crew.isExpired) {
                                markedElementIndex.push(index);
                            }
                        });
                        moveToTop(markedElementIndex);
                        scrollToTop();
                        vm.isAddCrewVisible = false;
                    };


                    actions[trackingConstants.DESCRIPANCY_TYPES.CURR_ILLEGAL] = function () {
                        var currIllegalCrews = TrackingHelper.getCurrentIllegalCrews(vm.selectedPairing.patternId);
                        var illegalCrewIdList = _.pluck(currIllegalCrews, 'crewProfileId') || [];
                        markedElementIndex.length = 0;
                        angular.forEach(vm.crewList, function (crew, index) {
                            if (illegalCrewIdList.indexOf(crew.crewProfileId) >= 0) {
                                crew.isIllegal = true;
                                markedElementIndex.push(index);
                            }
                        });
                        moveToTop(markedElementIndex);
                        scrollToTop();
                        vm.isAddCrewVisible = false;
                    };

                    actions[trackingConstants.DESCRIPANCY_TYPES.NEXT_ILLEGAL] = function () {
                        var nextIllegalList = TrackingHelper.getNextIllegalCrews(vm.selectedPairing.patternId);
                        var nextIllegalIds = _.pluck(nextIllegalList, 'crewProfileId') || [];
                        markedElementIndex.length = 0;
                        angular.forEach(vm.crewList, function (crew, index) {
                            if (nextIllegalIds.indexOf(crew.crewProfileId) >= 0) {
                                crew.isNextIllegal = true;
                                markedElementIndex.push(index);
                            }
                        });
                        moveToTop(markedElementIndex);
                        scrollToTop();
                        vm.isAddCrewVisible = false;
                    };

                    actions['ADD_CREW_WARNINGS'] = function () {
                        vm.selectedCrew = null;
                        vm.isAddCrewVisible = true;
                        scrollToBottom();
                    };

                    if (vm.crewList && vm.selectedPairing) {
                        !!actions[vm.selectedDiscrepancy.type] ?  actions[vm.selectedDiscrepancy.type]() :  actions['ADD_CREW_WARNINGS']();
                    }
                };
            },
            bindings: {
                selectedDiscrepancy: '<',
                crewList: '<',
                onCrewSelected: '&',
                onViewProfile: '&'
            }
        });
})
();
